import React, { useState } from 'react'
import { PieChart, Pie, ResponsiveContainer, Sector } from 'recharts'
import { FormattedMessage } from 'react-intl'
import {
  CardWrapper,
  CardBody,
  CardHeader,
  CardTitle,
  ChartWrapper,
  CenterLabel,
  LegendWrapper,
  LegendItem,
  LegendDot,
  FixedTooltip,
  FixedTooltipHeader,
  FixedTooltipDot,
  FixedTooltipValue
} from './style'
import AlertIconQuestion from '../AlertIconQuestion'

const CHART_HEIGHT_BY_SIZE = {
  sm: 180,
  md: 240,
  lg: 320
}

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={outerRadius + 2}
        outerRadius={outerRadius + 8}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  )
}
const Donutchartcard = ({
  titleId,
  titleDefaultMessage,
  helpTextId,
  helpTextDefaultMessage,
  segments,
  legendSegments,
  legendPosition = 'bottom',
  centerLabel,
  size = 'md',
  noBorder = false
}) => {
  const chartHeight = CHART_HEIGHT_BY_SIZE[size] || CHART_HEIGHT_BY_SIZE.md
  const showLegend = legendPosition !== 'none'
  const legendData = legendSegments || segments

  const [activeIndex, setActiveIndex] = useState(-1)
  const handleSectorEnter = (_, index) => setActiveIndex(index)
  const handleSectorLeave = () => setActiveIndex(-1)

  const hoveredSegment = activeIndex >= 0 ? segments[activeIndex] : null

  return (
    <CardWrapper $legendPosition={legendPosition} $noBorder={noBorder}>
      <CardBody>
        {titleId && (
          <CardHeader>
            <CardTitle>
              <FormattedMessage id={titleId} defaultMessage={titleDefaultMessage} />
            </CardTitle>
            {(helpTextId || helpTextDefaultMessage) && (
              <AlertIconQuestion title={helpTextId ? <FormattedMessage id={helpTextId} defaultMessage={helpTextDefaultMessage} /> : helpTextDefaultMessage} />
            )}
          </CardHeader>
        )}

        <ChartWrapper>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <PieChart>
              <Pie
                data={segments}
                dataKey="value"
                nameKey="key"
                innerRadius="42%"
                outerRadius="98%"
                paddingAngle={segments.length > 1 ? 1 : 0}
                startAngle={90}
                endAngle={-270}
                stroke="none"
                activeIndex={activeIndex}
                activeShape={renderActiveShape}
                onMouseEnter={handleSectorEnter}
                onMouseLeave={handleSectorLeave}
                isAnimationActive
              />
            </PieChart>
          </ResponsiveContainer>

          {centerLabel && <CenterLabel>{centerLabel}</CenterLabel>}

          {hoveredSegment && (
            <FixedTooltip $chartHeight={chartHeight}>
              <FixedTooltipHeader>
                <FixedTooltipDot color={hoveredSegment.fill} />
                <strong>
                  {hoveredSegment.labelId ? (
                    <FormattedMessage id={hoveredSegment.labelId} defaultMessage={hoveredSegment.labelDefaultMessage} />
                  ) : (
                    hoveredSegment.labelDefaultMessage || hoveredSegment.key
                  )}
                </strong>
              </FixedTooltipHeader>
              <FixedTooltipValue>{hoveredSegment.value}</FixedTooltipValue>
            </FixedTooltip>
          )}
        </ChartWrapper>
      </CardBody>

      {showLegend && (
        <LegendWrapper $legendPosition={legendPosition}>
          {legendData.map(({ key, fill, labelId, labelDefaultMessage }) => (
            <LegendItem key={key}>
              <LegendDot color={fill} />
              {labelId ? (
                <FormattedMessage id={labelId} defaultMessage={labelDefaultMessage} />
              ) : (
                labelDefaultMessage || key
              )}
            </LegendItem>
          ))}
        </LegendWrapper>
      )}
    </CardWrapper>
  )
}

export default Donutchartcard
